var store = {};

module.exports = {
	get: function (key) {
		return store[key];
	},

	set: function (pairs, value) {
		if (typeof pairs === 'string') {
			var temp = pairs;

			pairs = {};

			pairs[temp] = value;
		}

		var changed = [];

		for (var k in pairs) {
			if (store[k] !== pairs[k]) {
				changed.push({
					key: k,
					value: pairs[k]
				});
			}

			store[k] = pairs[k];
		}

		return changed;
	},

	remove: function (key) {
		var changed = key in store;

		delete store[key];

		return changed;
	}
};
